export const HIT_BOARD_STATUSV2 = 'HIT_BOARD_STATUSV2';
export const HIT_BOARD_INFOV2 = 'HIT_BOARD_INFOV2';
export const HIT_BOARD_DELETEV2 = 'HIT_BOARD_DELETEV2';
